// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Cookies from 'js-cookie'
import '@/assets/scss/app.scss';

import i18n from './lang'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/uupay/index.scss';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'


import VueLazyload from "vue-lazyload";
import store from './store';
// import './permission' // permission control
Vue.filter('formatPrice', function(price) {
  if (typeof price !== 'number') return price
  return String(Number(price).toFixed(0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})
Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueLazyload)

// google
// appid: 833829743330-1q7fvg42op6pigoiho8ts5g66uqqa7jg.apps.googleusercontent.com
// secret: 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

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js